<template>
  <div class="page">
    <v-skeleton-loader type="image" height="250" class="image-loader-mobile"></v-skeleton-loader>
    <v-row justify="start" no-gutters>
      <v-col class="text-left" cols="12">
        <div class="px-4">
          <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
          <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
          <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
          <v-skeleton-loader type="actions"></v-skeleton-loader>
        </div>
      </v-col>
    </v-row>
    <v-row class="mb-10" no-gutters>
      <v-col cols="12">
        <v-card flat tile class="pt-4">
          <v-divider></v-divider>
          <v-row class="pt-4 pb-4" no-gutters>
            <v-col align="start" cols="12" class="px-4">
              <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
              <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" align="start" class="card-border-top pt-2 px-4">
              <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
            </v-col>
            <v-col cols="12" align="start" class="card-border-top pt-2 px-4">
              <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'ProductDetailMobileLoader'
}
</script>

<style scoped>
  .image-loader-mobile >>> .v-skeleton-loader__image{
    height: 250px;
  }

  .page {
    flex: 1;
    background-color: #FFFFFF;
  }
</style>
